import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import RoutesHelper from 'helpers/RoutesHelper'

import { selectors as OrganizationsSelectors } from 'data/organizations'

import Overview from './Overview'
import Invoices from './Invoices'
import Informations from './Informations'
import Upgrade from './Upgrade'
import Switch from './Switch'
import { Text } from 'components/base'

const PAGES = {
  overview: Overview,
  upgrade: Upgrade,
  informations: Informations,
  invoices: Invoices,
  switch: Switch,
}

class SettingsBillingContainer extends Component {
  static propTypes = {
    subsection: PropTypes.string,
  }

  static defaultProps = {
    subsection: 'overview',
  }

  render() {
    const Page = PAGES[this.props.subsection] || Overview
    const { organization } = this.props
    return organization.product === 'enterprise' &&
      this.props.subsection !== 'invoices' ? (
      <div className="padding-vertical-large">
        <Text.Title className="margin-bottom-large">
          Your team is on an Enterprise plan.
        </Text.Title>
        <Text.Subtitle className="">
          Get in touch with your account manager for any information.
        </Text.Subtitle>
        <Link to={RoutesHelper.settingsOrganizationBillingInvoices()}>
          <Text.Action className="margin-top-medium">
            You can access your invoices.
          </Text.Action>
        </Link>
      </div>
    ) : (
      <Page />
    )
  }
}

export default connect(state => {
  return {
    organization: OrganizationsSelectors.getOrganization(state),
  }
})(SettingsBillingContainer)
